import _sfc_main from './CompanyLogo.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "fds-widget fds-company-logo", class: { "fds-ui-loading": _setup.isLoading, [`fds-company-logo--${_vm.format}`]: true, [`fds-company-logo--${_vm.size}`]: _vm.size } }, [_vm._t("root", function() {
    return [_setup.url ? _c("img", { ref: _setup.watchImage, staticClass: "fds-company-logo__img", attrs: { "src": _setup.url, "alt": _vm.alt } }) : _vm._e()];
  }, null, { storeModule: _setup.storeModule })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/company-logo/CompanyLogo.vue";
var CompanyLogo = __component__.exports;

export { CompanyLogo as default };
